"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _constants = require("@seedlang/constants");
var _diff = require("diff");
var _src = require("@seedlang/utils/src");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var WordTranslateCardWrapper = function WordTranslateCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "helpClickedCount", _descriptor, _this);
      _initializerDefineProperty(_this, "showHelp", _descriptor2, _this);
      _state.DeckUI.enrichWord(_this.props.card);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "hideOnboardingPopups",
      value: function hideOnboardingPopups() {
        if (!_state.DeckUI.user.wasUiElementSeen('reviewIconOnboarding')) {
          _state.AppUI.designateUiElementAsSeen('reviewIconOnboarding');
        }
        if (!_state.DeckUI.user.wasUiElementSeen('toggleKeyboardMicrophoneOnboarding')) {
          _state.AppUI.designateUiElementAsSeen('toggleKeyboardMicrophoneOnboarding');
        }
      }
    }, {
      key: "message",
      get: function get() {
        if (this.props.card.cardTypeSlug === 'number_translate') {
          return "Write this number in ".concat(_constants.Languages[this.props.card.word.languageId]);
        }
        if (this.props.card.word && this.props.card.word.wordType) {
          return "Translate this ".concat(this.props.card.word.wordType.formattedName);
        }
        return 'Translate this word';
      }
    }, {
      key: "icons",
      get: function get() {
        var ary = [];
        if (!this.props.cardState.revealed && !_state.AppUI.user.blockMediaAccess) {
          ary.push('toggleMicrophone');
        }
        if ((0, _utils.isPresent)(this.props.card.grammarTip)) {
          ary.push('grammarTip');
        }
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed) {
          ary.push('cardComments');
        }
        if (this.props.cardState.revealed && !_state.DeckUI.showLoadingIcon && (_state.DeckUI.deck.hasGrammarDescription || _state.DeckUI.deck.hasTreeNodeGrammarDescription)) {
          ary.push('deckGrammar');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        if (this.props.cardState.revealed) {
          ary.push('vocabCard');
        }
        return ary;
      }
    }, {
      key: "showHelpButton",
      get: function get() {
        if (this.props.card.word.targetText.length < 3) {
          return this.helpClickedCount < 1;
        }
        return this.helpClickedCount < 2;
      }
    }, {
      key: "numSections",
      get: function get() {
        return this.props.cardState.revealed && this.props.card.hasTargetVideoClip ? 3 : 2;
      }
    }, {
      key: "sectionHeight",
      get: function get() {
        var height;
        height = _state.DeckUI.layout.heightForCardSections(this.numSections, 0, false);
        if (_state.DeckUI.layout.isNative && _state.DeckUI.layout.keyboardVisible) {
          var padding = _state.DeckUI.layout.isAndroid && !_state.DeckUI.layout.hasNativeMenuBar ? 50 : 30;
          height = height + _state.DeckUI.layout.buttonHeight - padding;
        }
        if (this.showUserInput) {
          var userInputHeight = _state.DeckUI.layout.userInputHeight / this.numSections;
          return height - userInputHeight;
        } else {
          return height;
        }
      }
    }, {
      key: "vocabCardIncorrect",
      get: function get() {
        return this.props.cardState.revealed && !this.props.userCard.correct;
      }
    }, {
      key: "arrowBoxes",
      get: function get() {
        return {
          toggleKeyboardMicrophoneOnboarding: !this.props.cardState.revealed,
          reviewIconOnboarding: !_state.DeckUI.reviewDeck && this.props.cardState.revealed,
          spacedRepetitionOnboarding: _state.DeckUI.reviewDeck && this.props.cardState.revealed,
          helpMeOnboarding: !this.props.cardState.revealed && !_state.DeckUI.layout.isNative,
          noteOnboarding: _state.DeckUI.reviewDeck && this.props.cardState.revealed,
          commentOnboarding: this.props.cardState.revealed,
          vocabCardOnboarding: !_state.DeckUI.reviewDeck && this.props.cardState.revealed,
          translateVocab: this.showUserInput && !this.props.cardState.revealed
        };
      }
    }, {
      key: "possibleArrowBoxes",
      get: function get() {
        return (0, _lodash.keys)(this.arrowBoxes);
      }
    }, {
      key: "showOnboarding",
      value: function showOnboarding(slug) {
        var _this$props$card, _this$props$card2;
        return !((_this$props$card = this.props.card) !== null && _this$props$card !== void 0 && (_this$props$card = _this$props$card.cardState) !== null && _this$props$card !== void 0 && _this$props$card.onboardingTipSeen) || ((_this$props$card2 = this.props.card) === null || _this$props$card2 === void 0 || (_this$props$card2 = _this$props$card2.cardState) === null || _this$props$card2 === void 0 ? void 0 : _this$props$card2.lastOnboardingTipSeen) === slug;
      }
    }, {
      key: "currentArrowBox",
      get: function get() {
        var _this2 = this;
        var arrowBox;
        (0, _lodash.each)(this.possibleArrowBoxes, function (slug) {
          if (_this2.showOnboarding(slug) && _this2.arrowBoxes[slug] && !_state.DeckUI.user.wasUiElementSeen(slug) && _state.AppUI.userCreatedInLastWeek && !arrowBox) {
            arrowBox = slug;
          }
        });
        return arrowBox;
      }
    }, {
      key: "showUserInput",
      get: function get() {
        return _state.DeckUI.user.vocabCardAudio && _state.DeckUI.canRecordMedia && _state.DeckUI.layout.showUserInput;
      }
    }, {
      key: "hint",
      get: function get() {
        var _this3 = this;
        if (this.helpClickedCount === 0) {
          return;
        }
        var str = '';
        if (this.props.card.word.isNoun && (0, _utils.isPresent)(this.props.card.word.gender) && !this.props.card.word.useParenthesesOnGender && !this.props.card.word.articleIsHidden) {
          if (this.props.card.word.languageId === 'DE') {
            str = 'd__ ';
          } else if (this.props.card.word.languageId === 'FR') {
            if (this.props.card.word.plural) {
              str = 'l__ ';
            } else if (this.props.card.word.articleHasApostrophe || _constants.Constants.LETTERS_THAT_TAKE_APOSTROPHE_IN_FR.includes(this.props.card.word.targetText[0])) {
              if (this.helpClickedCount === 1) {
                str = 'l_';
              } else if (this.helpClickedCount === 2) {
                str = 'l\'';
              }
            } else {
              str = 'l_ ';
            }
          } else if (this.props.card.word.languageId === 'ES') {
            if (this.props.card.word.plural) {
              str = 'l__ ';
            } else {
              str = '__ '; // el / la
            }
          }
        }
        var targetCharactersToReveal = [];
        if (this.props.card.word.targetText.length > 1) {
          targetCharactersToReveal.push(0);
        }
        if (this.props.card.word.languageId === 'ES' && this.props.card.word.isNoun && this.props.card.word.targetText.length > 3) {
          targetCharactersToReveal.push(this.props.card.word.targetText.length - 2); // penultimate char
        } else if (this.props.card.word.targetText.length > 3) {
          targetCharactersToReveal.push(this.props.card.word.targetText.length - 1); // last char
        }
        var targetHint = '_'.repeat(this.props.card.word.targetText.length);
        // add spaces to targetCharactersToReveal
        (0, _lodash.each)(this.props.card.word.targetText.split(''), function (_char, index) {
          if (_char === ' ' || _char === '.') {
            targetCharactersToReveal.push(index);
            targetCharactersToReveal.push(index + 1);
          }
        });
        if (this.helpClickedCount > 1) {
          (0, _lodash.each)(targetHint, function (_char2, index) {
            if (index % 3 === 1 && !targetCharactersToReveal.includes(index)) {
              targetCharactersToReveal.push(index);
            }
          });
        }
        // reveal characters
        targetCharactersToReveal.forEach(function (charIndex) {
          targetHint = targetHint.slice(0, charIndex) + _this3.props.card.word.targetText[charIndex] + targetHint.slice(charIndex + 1, targetHint.length);
        });
        str = str + targetHint;
        return str;
      }
    }, {
      key: "mediaStore",
      get: function get() {
        return _state.DeckUI.mediaStores[this.props.card.id];
      }
    }, {
      key: "afterVideoPlayback",
      value: function afterVideoPlayback() {
        var _this4 = this;
        try {
          if (this.showUserInput && _state.DeckUI.canRecordMedia && !this.props.cardState.audioHasAutoPlayed) {
            this.props.cardState.set('audioHasAutoPlayed', true);
            if (this.mediaStore) {
              // On native, we need to wait for the recording to be ready
              if (this.mediaStore.isNative && this.mediaStore.hasFinishedRecording && !this.mediaStore.hasNativeSound) {
                this.mediaStore.autoPlay = true;
                if (!this.mediaStore.nativeSoundIsLoading && this.mediaStore.nativeAudioRecorder) {
                  this.mediaStore.nativeSoundIsLoading = true;
                }

                // Set up a fallback timer to check if recording becomes ready
                var attempts = 0;
                var maxAttempts = 20; // 2 seconds total
                var checkInterval = setInterval(function () {
                  attempts++;
                  console.log("[WordTranslateCard] Checking if recording is ready (attempt ".concat(attempts, "/").concat(maxAttempts, ")"), {
                    hasNativeSound: _this4.mediaStore.hasNativeSound,
                    nativeSoundIsLoading: _this4.mediaStore.nativeSoundIsLoading
                  });
                  if (_this4.mediaStore.hasNativeSound) {
                    clearInterval(checkInterval);
                    console.log('[WordTranslateCard] Recording is now ready, playing...');
                    try {
                      _this4.mediaStore.play();
                      console.log('[WordTranslateCard] User recording play() called successfully');
                    } catch (error) {
                      console.error('[WordTranslateCard] Error playing user recording:', error);
                    }
                  } else if (attempts >= maxAttempts) {
                    clearInterval(checkInterval);
                    console.warn('[WordTranslateCard] Recording did not become ready after 2 seconds');
                  }
                }, 100);
              } else {
                // For web or when recording is already ready
                var canPlayAudio = this.mediaStore.hasNativeSound || this.mediaStore.hasUrl || this.mediaStore.hasRecording;
                if (canPlayAudio) {
                  try {
                    this.mediaStore.play();
                    console.log('[WordTranslateCard] User recording play() called successfully');
                  } catch (error) {
                    console.error('[WordTranslateCard] Error playing user recording:', error);
                  }
                } else {
                  console.log('[WordTranslateCard] No audio available to play', {
                    hasNativeSound: this.mediaStore.hasNativeSound,
                    hasUrl: this.mediaStore.hasUrl,
                    hasRecording: this.mediaStore.hasRecording
                  });
                }
              }
            } else {
              console.warn('[WordTranslateCard] No mediaStore available for user recording playback');
            }
          }
        } catch (error) {
          console.error('[WordTranslateCard] ERROR in afterVideoPlayback:', error);
          console.error('[WordTranslateCard] Error stack:', error.stack);
        }
      }
    }, {
      key: "onHelpButtonClicked",
      value: function onHelpButtonClicked() {
        this.helpClickedCount = this.helpClickedCount += 1;
        _state.DeckUI.warning = '';
      }
    }, {
      key: "onTextInputChange",
      value: function onTextInputChange(val) {
        if (_state.DeckUI.user.evaluateVocabOnKeystroke) {
          _state.DeckUI.onWordInputChangeAndEvaluate(this.props.card, this.props.cardState, this.props.userCard, val);
        } else {
          _state.DeckUI.onWordInputChange(this.props.cardState, val);
        }
      }
    }, {
      key: "setShowHelp",
      value: function setShowHelp(showHelp) {
        this.showHelp = showHelp;
        if (showHelp) {
          this.onShowHelp();
        } else {
          this.onLeaveHelp();
        }
      }
    }, {
      key: "onLeaveHelp",
      value: function onLeaveHelp() {
        if (this.props.cardState && (0, _utils.isPresent)(this.props.cardState)) {
          this.props.cardState.resetWithinCard();
        }
        if (this.props.card.sentence && this.props.card.sentence.state) {
          this.props.card.sentence.state.reset();
        }
      }
    }, {
      key: "onShowHelp",
      value: function onShowHelp() {
        _state.DeckUI.designateUiElementAsSeen('helpMe');
        if (this.props.cardState) {
          this.props.cardState.set('showHelp', true);
          this.props.cardState.set('helpWasShown', true);
        }
      }
    }, {
      key: "textToDiffArray",
      value: function textToDiffArray(text) {
        var _this$props$card3;
        if ((0, _src.isBlank)((_this$props$card3 = this.props.card) === null || _this$props$card3 === void 0 ? void 0 : _this$props$card3.word)) {
          return;
        }
        var articlesList = (0, _lodash.values)(_constants.Constants.SINGULAR_ARTICLES[this.props.card.word.languageId]).concat((0, _lodash.values)(_constants.Constants.PLURAL_ARTICLES[this.props.card.word.languageId]));
        return (0, _lodash.flatten)(text.split(/(?=\s)/).map(function (item) {
          return articlesList.includes(item) ? item : item.split('');
        }));
      }
    }, {
      key: "diff",
      value: function diff(displayedText, ref) {
        if ((0, _src.isBlank)(displayedText) && (0, _src.isBlank)(ref)) {
          return;
        }
        if ((0, _src.isBlank)(ref)) {
          return displayedText;
        }
        var diff = (0, _diff.diffArrays)(this.textToDiffArray(ref), this.textToDiffArray(displayedText), {
          maxEditLength: 3,
          ignoreCase: !_state.DeckUI.user.enforceCasing
        });
        if ((0, _src.isBlank)(diff)) {
          return displayedText;
        }
        return diff.map(function (part, index) {
          if (!part.removed) {
            return /*#__PURE__*/_react["default"].createElement("span", {
              key: index,
              className: part.added ? 'diff' : 'no-diff'
            }, part.value.join(''));
          }
        });
      }
    }, {
      key: "correctAnswer",
      get: function get() {
        var _this$props$card$word, _this$props$card$word2, _this$props$card$word3;
        return (_this$props$card$word = this.props.card.word) !== null && _this$props$card$word !== void 0 && _this$props$card$word.hideDefiniteArticle ? (_this$props$card$word2 = this.props.card.word) === null || _this$props$card$word2 === void 0 ? void 0 : _this$props$card$word2.targetText : (_this$props$card$word3 = this.props.card.word) === null || _this$props$card$word3 === void 0 ? void 0 : _this$props$card$word3.targetTextWithDefiniteArticle;
      }
    }, {
      key: "correctAnswerWithDiff",
      get: function get() {
        if (this.props.card.word.hideDefiniteArticle) {
          this.diff(this.props.card.word.targetText, this.props.cardState.textEntry);
        }
        return this.diff(this.props.card.word.targetTextWithDefiniteArticle, this.props.cardState.textEntry);
      }
    }, {
      key: "wrongAnswerWithDiff",
      get: function get() {
        if (this.props.card.word.hideDefiniteArticle) {
          this.diff(this.props.cardState.textEntry, this.props.card.word.targetText);
        }
        return this.diff(this.props.cardState.textEntry, this.props.card.word.targetTextWithDefiniteArticle);
      }
    }, {
      key: "showExpandedTarget",
      get: function get() {
        return this.props.cardState.revealed && (!this.vocabCardIncorrect || (0, _src.isBlank)(this.props.cardState.textEntry));
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          numSections: this.numSections,
          sectionHeight: this.sectionHeight,
          vocabCardIncorrect: this.vocabCardIncorrect,
          possibleArrowBoxes: this.possibleArrowBoxes,
          currentArrowBox: this.currentArrowBox,
          showUserInput: this.showUserInput,
          afterVideoPlayback: this.afterVideoPlayback,
          showHelpButton: this.showHelpButton,
          warning: _state.DeckUI.warning,
          hint: this.hint,
          onHelpButtonClicked: this.onHelpButtonClicked,
          icons: this.icons,
          onTextInputChange: this.onTextInputChange,
          message: this.message,
          setShowHelp: this.setShowHelp,
          hideOnboardingPopups: this.hideOnboardingPopups,
          onHideArrowBox: this.hideOnboardingPopups,
          diff: this.diff,
          correctAnswer: this.correctAnswer,
          correctAnswerWithDiff: this.correctAnswerWithDiff,
          wrongAnswerWithDiff: this.wrongAnswerWithDiff,
          showExpandedTarget: this.showExpandedTarget
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "helpClickedCount", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 0;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "showHelp", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "hideOnboardingPopups", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "hideOnboardingPopups"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "message", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "message"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showHelpButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showHelpButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "numSections", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "numSections"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sectionHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "vocabCardIncorrect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "vocabCardIncorrect"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "arrowBoxes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "arrowBoxes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "possibleArrowBoxes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "possibleArrowBoxes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showOnboarding", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "showOnboarding"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentArrowBox", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "currentArrowBox"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showUserInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showUserInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hint", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hint"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mediaStore", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mediaStore"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterVideoPlayback", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterVideoPlayback"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onHelpButtonClicked", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onHelpButtonClicked"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onTextInputChange", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onTextInputChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setShowHelp", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setShowHelp"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onLeaveHelp", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onLeaveHelp"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onShowHelp", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onShowHelp"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "textToDiffArray", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "textToDiffArray"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "diff", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "diff"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswerWithDiff", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswerWithDiff"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wrongAnswerWithDiff", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wrongAnswerWithDiff"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showExpandedTarget", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showExpandedTarget"), _class2.prototype), _class2)) || _class;
};
WordTranslateCardWrapper.displayName = 'WordTranslateCardWrapper';
var _default = exports["default"] = WordTranslateCardWrapper;